import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomCmsService } from '@core/data-access';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChatMenuComponentService } from '../chat-menu-component.service';

@Component({
  selector: 'ui-chat-menu-mobile',
  templateUrl: './chat-menu-mobile.component.html',
  styleUrls: ['./chat-menu-mobile.component.scss'],
  providers: [ChatMenuComponentService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChatMenuMobileComponent implements OnInit {
  public iconType = CUSTOM_ICON_TYPE;
  chatLinksLength$: Observable<number>;

  constructor(
    public cmsService: CustomCmsService,
    public chatMenuComponentService: ChatMenuComponentService,
  ) {}

  ngOnInit(): void {
    this.chatLinksLength$ = this.cmsService
      .getContentSlot('ChatMobileMenuSlot')
      .pipe(map((data) => data.components?.length));
  }
}
